import { useState } from "react";
import ChatBot from "./ChatBot";

export default function ChatBotButton() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* الزرار العائم */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed bottom-8 md:bottom-6 left-4 md:left-6 bg-gradient-to-r from-blue-500 to-blue-600 text-white w-20 h-20 md:w-20 md:h-20 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl z-50 transition-all transform hover:scale-105 p-3.5"
        style={{
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        }}
      >
        <img 
          src="/chatbot.png" 
          alt="Chat Bot"
          className="w-full h-full object-contain"
        />
      </button>

      {/* الشات يظهر لما الزرار يضغط */}
      {isOpen && (
        <div 
          className="fixed bottom-20 left-4 w-[280px] h-[400px] z-50 rounded-2xl  transform origin-bottom-left"
          style={{
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
            animation: 'slideUp 0.3s ease-out'
          }}
        >
          <ChatBot />
        </div>
      )}
    </>
  );
}
